import React, { useState, useEffect  } from 'react';

import './App.css';
import {Switch, Route, Redirect} from 'react-router-dom';
import TeacherSignUp from './schoolzone/Teacher/TeacherSignUp';
import ParentPortalIntro from './parentportal/intro';
import ParentPortalSignUp from './parentportal/signup';
import ParentPortalSignIn from './parentportal/signin';
import WidgetsSignIn from './widgets/signin';
import WidgetsSignUp from './widgets/signup';
import WidgetsTeacherSignUp from './widgets/teacher-signup';
import WidgetsStripeForm from './widgets/stripe';
import WidgetsStripeCancelForm from './widgets/stripe-cancel';
import ParentPortalDashboard from './parentportal/dashboard';
import ParentPortalConfirmation from './parentportal/confirmation';
import DevToolsUGC from './devtools/ugc';
import TeacherClassroom from './schoolzone/Teacher/Classroom';
import UluFooter from './core/footer';
import AppContext from 'core/appContext';
import getLanguage from 'getLanguage';
import UIBlocker from 'core/UIBlocker';
import SchoolZoneFooter from 'core/footer/SchoolZoneFooter';
import { initPixel } from './Facebook'

function App() {
  const [lang, setLang] = useState(getLanguage())
  const [blockUI, setBlockUI] = useState(false)
  const context = {
    ...AppContext.value,
    lang,
    setLang,
    blockUI,
    setBlockUI,
  };

  useEffect(() => {
    if (window.location.pathname.startsWith('/widgets/teacher-signup'))
      initPixel('25133786359551975')
    else if (window.location.pathname.startsWith('/widgets/signup') ||
             window.location.pathname.startsWith('/widgets/stripe') ||
             window.location.pathname.startsWith('/widgets/stripe-cancel'))
      initPixel('1306621258107487')
    else
      initPixel('654631560773726')
  }, [])

  // We do not want to use the portal.ululab.com subdomain anymore.
  // We are thus redirecting requests to the play.ululab.com subdomain
  // Maintaining both create issues as the localStorage content (token, userInfo, ...)
  // is specific for the subdomain and cannot be shared between both subdomains.
  // A different solution would be to use domain-wide cookies instead of localStorage (limit of 4Kb for all cookies).
  if (window.location.href.includes("portal.ululab.com"))
    window.location.href = window.location.href.replace("portal.ululab.com","play.ululab.com")

  return (
    <AppContext.Provider value={context}>
      <UIBlocker shown={blockUI} />
      <Switch>
        <Route exact path="/" component={ParentPortalIntro}/>
        <Route exact path="/devtools/ugc" component={DevToolsUGC} />
        <Route exact path="/signup" component={ParentPortalSignUp}/>
        <Route exact path="/signin" component={ParentPortalSignIn}/>
        <Route exact path="/widgets/signin" component={WidgetsSignIn}/>
        <Route exact path="/widgets/signup" component={WidgetsSignUp}/>
        <Route exact path="/widgets/teacher-signup" component={WidgetsTeacherSignUp}/>
        <Route exact path="/widgets/stripe" component={WidgetsStripeForm}/>
        <Route exact path="/widgets/stripe-cancel" component={WidgetsStripeCancelForm}/>
        <Route exact path="/dashboard" component={ParentPortalDashboard}/>
        <Route exact path="/confirmation" component={ParentPortalConfirmation}/>
        <Route exact path="/schoolzone/teacher/classroom/:id" component={TeacherClassroom} />
        <Route path="/schoolzone/teacher/*" component={TeacherSignUp} />
        <Route path="*">
            <Redirect to="/" />
        </Route>
      </Switch>
      <Switch>
        <Route path="/widgets/*" />
        <Route path="/schoolzone/teacher/*" component={SchoolZoneFooter} />
        <Route path="*" component={UluFooter} />
      </Switch>
    </AppContext.Provider>
  )
}

export default App;
